/**
 * registerThemes
 * ------------------------
 * This is the ONLY file in the entire codebase that knows the concrete
 * list of themes and their import paths. It lives in `themes/`, not in
 * `core/`, and it's called once at app bootstrap — Core itself never
 * imports this file or any theme module.
 *
 * Adding a new theme = adding one entry here. No existing theme file,
 * and no engine file, is ever touched.
 */
export function registerThemes(engine) {
    engine.registerTheme({
        id: 'default',
        load: () => import('./default'),
        meta: { name: 'Vania Default', category: 'system', premium: false },
    });
    engine.registerTheme({
        id: 'vania',
        load: () => import('./vania'),
        meta: { name: 'Vania', category: 'brand', premium: false },
    });
    engine.registerTheme({
        id: 'dark-vania',
        load: () => import('./dark-vania'),
        meta: { name: 'Dark Vania', category: 'brand', premium: false },
    });
    engine.registerTheme({
        id: 'super-admin-command',
        load: () => import('./super-admin'),
        meta: { name: 'Vania Super Admin Command', category: 'system', premium: false },
    });
    engine.registerTheme({
        id: 'ahoora',
        load: () => import('./ahoora'),
        meta: { name: 'Ahoora', category: 'brand', premium: false },
    });
    engine.registerTheme({
        id: 'karen',
        load: () => import('./karen'),
        meta: { name: 'Karen', category: 'brand', premium: false },
    });
    engine.registerTheme({
        id: 'yona',
        load: () => import('./yona'),
        meta: { name: 'Yona', category: 'brand', premium: false },
    });
    engine.registerTheme({
        id: 'kayan',
        load: () => import('./kayan'),
        meta: { name: 'Kayan', category: 'brand', premium: false },
    });
    engine.registerTheme({
        id: 'armita',
        load: () => import('./armita'),
        meta: { name: 'Armita', category: 'brand', premium: false },
    });
    // Future themes follow the same one-line pattern, e.g.:
    // engine.registerTheme({
    //   id: 'midnight',
    //   load: () => import('./midnight'),
    //   meta: { name: 'Midnight', category: 'brand', premium: true },
    // });
}
